<script setup>
import {computed, inject, provide, useSlots} from 'vue'

const slots = useSlots()

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: '',
    },
    localizetitle: {
        type: Boolean,
        required: false,
        default: false,
    },
    value: {
        type: String,
        required: true
    },
    active: {
        type: Boolean,
        required: false,
        default: false
    },
})

const selectedTitle = inject('selectedTitle')
const isVisible = computed(() => {
    return props.value === selectedTitle.value;
})

provide('containerTabIsVisible', isVisible)

</script>
<template>
    <div
        v-show="value === selectedTitle"
    >
        <slot></slot>

        <div
            v-if="slots['action-left'] || slots['action-right']"
            class="flex justify-between -mx-4 md:-mx-6 lg:-mx-8 -mb-4 md:-mb-6 lg:-mb-8 px-4 md:px-6 lg:px-8 py-2 transform translate-y-px relative mt-4"
        >
            <div><slot name="action-left"></slot></div>
            <div><slot name="action-right"></slot></div>
        </div>
    </div>
</template>
